export default {
  methods: {
    // returns the report status label
    getReportsStatus(status) {
      return this.myReportsStatus[status] || status
    },
    getReportLayoutTypesByDataModel(prop) {
      return this.getReportLayoutTypesFilter.filter(el => el.id.includes(prop));
    }
  },
  computed: {
    myReportsStatus() {
      return {
        'REQUESTED': this.$t('reports.status.requested'),
        'PROCESSING': this.$t('reports.status.processing'),
        'FAIL': this.$t('reports.status.fail'),
        'SUCCESS': this.$t('reports.status.success')
      };
    },
    reportLayoutTypes() {
      return {
        'REPORT_MOVEMENT_RECORD_DEFAULT': this.$t('reports.reportLayouts.reportMovementRecordDefault'),
        'REPORT_MOVEMENT_RECORD_ANALYTICAL': this.$t('reports.reportLayouts.reportMovementRecordAnalytical'),
        'REPORT_MOVEMENT_RECORD_OPERATIONAL' : this.$t('reports.reportLayouts.reportMovementRecordOperational'),
        'REPORT_FILE_DATA_ERRORS': this.$t('reports.reportLayouts.reportFileDataErrors'),
        'REPORT_FILE_DATA_CORRECTION_FILE': this.$t('reports.reportLayouts.reportFileDataCorrectionFile'),
        'REPORT_FILE_DATA_CRITICISM_RETURN': this.$t('reports.reportLayouts.reportFileDataCriticismReturn'),
      };
    },
    // returns the list of statuses used in the page filter
    myReportsStatusFilter() {
      return Object.entries(this.myReportsStatus).map(
        ([id, name]) => ({ id, name }));
    },
    getReportLayoutTypesFilter() {
      return Object.entries(this.reportLayoutTypes).map(
        ([id, name]) => ({ id, name }));
    },
  }
}
